import { render } from "./products.vue?vue&type=template&id=546fb8e4&scoped=true&ts=true"
import script from "./products.vue?vue&type=script&lang=ts"
export * from "./products.vue?vue&type=script&lang=ts"

import "./products.vue?vue&type=style&index=0&id=546fb8e4&scoped=true&lang=scss"

import exportComponent from "D:\\otimes-en\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546fb8e4"]])

export default __exports__